import { render, staticRenderFns } from "./LevelChangeGroup.vue?vue&type=template&id=18d6b4be"
import script from "./LevelChangeGroup.js?vue&type=script&lang=js&external"
export * from "./LevelChangeGroup.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports